/* eslint-disable camelcase */
import { useReducer, useEffect, useState } from "react";

import { Card } from "@mui/material";

import DataTable from "examples/Tables/DataTable";

import dataTableData from "layouts/agent/overview/components/Content/data/dataTableData";
import Query from "layouts/agent/overview/components/Content/components/Query";

import getAgentRecord from "api/agent/report";

function reducer(state, action) {
  switch (action.type) {
    case "rows": {
      return { ...state, rows: action.value };
    }
    case "pageOptions.total": {
      return { ...state, total: action.value };
    }
    case "pageOptions.numbers": {
      return { ...state, numbers: action.value };
    }
    default: {
      throw new TypeError(`不接受类型: ${action.type}`);
    }
  }
}
function reducerQuery(state, action) {
  switch (action.type) {
    case "page": {
      return { ...state, page: action.value };
    }
    case "per_page": {
      return { ...state, per_page: action.value };
    }
    case "start_date": {
      return { ...state, start_date: action.value };
    }
    case "end_date": {
      return { ...state, end_date: action.value };
    }
    case "campaign_name": {
      return { ...state, campaign_name: action.value };
    }
    case "userid": {
      return { ...state, userid: action.value };
    }
    default: {
      throw new TypeError(`不接受类型: ${action.type}`);
    }
  }
}
function Content() {
  const [dataQuery, dispatchDataQuery] = useReducer(reducerQuery, {
    page: 1,
    per_page: 10,
    start_date: "",
    end_date: "",
    campaign_name: "",
    userid: "",
  });
  const [dataTable, dispatchDataTable] = useReducer(reducer, dataTableData);
  const [pageOptions, dispatchPageOptions] = useReducer(reducer, {
    total: 0,
    numbers: [],
  });
  const [total, setTotal] = useState([]);

  useEffect(async () => {
    const result = await getAgentRecord(dataQuery);
    if (result) {
      dispatchDataTable({
        type: "rows",
        value: result?.list ?? [],
      });
      dispatchPageOptions({
        type: "pageOptions.total",
        value: result?.meta?.pagination?.total ?? 0,
      });
      dispatchPageOptions({
        type: "pageOptions.numbers",
        value: new Array(result?.meta?.pagination?.total_pages ?? 0)
          .fill(0)
          .map((item, index) => index + 1),
      });
      setTotal(
        [result?.meta?.total].map((item) => ({
          date: "总计>>SI<<TOTAL",
          ...item,
        }))
      );
    }
  }, [dataQuery]);

  const handleEntriesPerPageChange = (value) => {
    dispatchDataQuery({ type: "per_page", value });
  };
  const handlePageIndexChange = (value) => {
    dispatchDataQuery({ type: "page", value });
  };
  const handleQuery = ({
    startDate: start_date,
    endDate: end_date,
    campaignName: campaign_name,
    userId: userid,
  }) => {
    dispatchDataQuery({ type: "start_date", value: start_date });
    dispatchDataQuery({ type: "end_date", value: end_date });
    dispatchDataQuery({ type: "campaign_name", value: campaign_name });
    dispatchDataQuery({ type: "userid", value: userid });
  };
  return (
    <Card>
      <Query onQuery={handleQuery} />
      <DataTable
        table={dataTable}
        pageOptions={pageOptions}
        total={total}
        entriesPerPage={false}
        showEntriesPerPage
        isSorted={false}
        entriesPerPageChange={handleEntriesPerPageChange}
        pageIndexChange={handlePageIndexChange}
      />
    </Card>
  );
}
export default Content;
